<template>
  <div class="jiaoDingLiuShuiXianKanban">
    <h1 style="text-align: center; margin-top: 0vh; line-height: 8vh;">轿顶流水线看板</h1>
    <div style="background-color: #2D4054; margin: 2vh 1vh 0vh 1vh;">
      <div style="width: 66%; float: left;">
        <div style="margin: 1vh 0 0 1%;">
          <div v-show="ifShow" style="width: 30%; float: left; margin-left: 3%;">
            <div class="timeText" style="float: left;">本年</div>
            <div
                ref="numberGrow1"
                style="float: left;"
                :data-time="time"
                class="number-grow"
                :data-value="year">
              0
            </div>
            <div class="clear"/>
          </div>
          <div style="width: 30%; float: left; margin-left: 3%;">
            <span class="timeText" style="float: left;">本月</span>
            <span
                ref="numberGrow2"
                style="float: left;"
                :data-time="time"
                class="number-grow"
                :data-value="month">0</span>
            <div class="clear"/>
          </div>
          <div style="width: 30%; float: left; margin-left: 3%;">
            <span class="timeText" style="float: left;">本日</span>
            <span
                ref="numberGrow3"
                style="float: left;"
                :data-time="time"
                class="number-grow"
                :data-value="day">0</span>
            <div class="clear"/>
          </div>
          <div class="clear"/>
        </div>
        <div>
          <div style="font-size: 3vh; float: left; margin: 3vh 0 0 1vh; position: absolute; z-index: 999;">* 开工</div>
          <div class="chart1" style="width: 47%; height: 30vh; float: left; margin-left: 6%;"/>
          <div class="chart2" style="width: 47%; height: 30vh; float: left;"/>
          <div class="clear"/>
        </div>
      </div>
      <div style="width: 34%; float: right;">
        <el-table :data="partKG" height="37vh" size="medium" style="font-size: 2.6vh;">
          <el-table-column prop="factoryNum" label="PC号" :width="fontSize(1.8)"/>
          <el-table-column prop="materialDescription" label="柜型"/>
        </el-table>
      </div>
      <div class="clear"/>
    </div>
    <div style="margin: 0vh;">
      <div class="chart3" style="width: 100%; height: 36vh;"/>
    </div>
    <div style="margin: 1vh;">
      <el-row style="color: #42FFFF; background-color: #253C65;">
        <el-col :span="12">
          <div class="orderTable">当前生产订单</div>
        </el-col>
        <el-col :span="12">
          <div class="orderTable">下台生产订单</div>
        </el-col>
      </el-row>
      <el-row style="background-color: #2A4566;">
        <el-col :span="3"><div class="orderTable">{{nowOrder.factoryNum}}</div></el-col>
        <el-col :span="3"><div class="orderTable"><marquee>{{nowOrder.materialDescription}}</marquee></div></el-col>
        <el-col :span="3"><div class="orderTable">{{nowOrder.materialNo}}</div></el-col>
        <el-col :span="3"><div class="orderTable">{{nowOrder.deliveryDate}}</div></el-col>
        <el-col :span="3"><div class="orderTable">{{nextOrder.factoryNum}}</div></el-col>
        <el-col :span="3"><div class="orderTable"><marquee>{{nextOrder.materialDescription}}</marquee></div></el-col>
        <el-col :span="3"><div class="orderTable">{{nextOrder.materialNo}}</div></el-col>
        <el-col :span="3"><div class="orderTable">{{nextOrder.deliveryDate}}</div></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import "echarts-liquidfill";
  export default {
    data() {
      return {
        ifShow: new Date().toDateString() !== "Thu Sep 10 2020",
        date: new Date().getTime(),
        lineNO: 0,
        time: 2,
        year: 0,
        month: 0,
        day: 0,
        myChart1: null,
        myChart2: null,
        myChart3: null,
        lastDayPlanNum: 0,
        lastDayNum: 0,
        todayPlanNum: 0,
        todayNum: 0,
        partKG: [],
        KGList: [],
        KGHour: [],
        KGValue: [],
        nowOrder: {
          factoryNum: "",
          materialDescription: "",
          materialNo: "",
          deliveryDate: "",
        },
        nextOrder: {
          factoryNum: "",
          materialDescription: "",
          materialNo: "",
          deliveryDate: "",
        },
      };
    },
    mounted() {
      this.lineNO = this.$route.params.lineNO;
      this.getSpAssemblyPartLineList();
      this.getPartKGList();
      this.getPartKGHourSList();
      this.getPartKGsList();
      this.myChart1 = this.$echarts.init(document.querySelector(".chart1"));
      this.myChart2 = this.$echarts.init(document.querySelector(".chart2"));
      this.myChart3 = this.$echarts.init(document.querySelector(".chart3"));
      setInterval(() => {
        this.getSpAssemblyPartLineList();
        this.getPartKGList();
        this.getPartKGHourSList();
        this.getPartKGsList();
        this.date = new Date().getTime();
      }, 1000 * 60 * 5);
      setInterval(() => {
        this.partKG.push(this.partKG[0]);
        this.partKG.splice(0, 1);
      }, 4000);
    },
    methods: {
      getSpAssemblyPartLineList() {
        let params = {
          date: this.date,
          line: this.lineNO ,
          strType: "检修盒",
        };
        this.$http.get("basic","kanban/getSpAssemblyPartLineList", params).then(res => {
          for(let item of res) {
            if(item.name === "本年开工数量") {
              this.year = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "本月开工数量") {
              this.month = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "本日开工数量") {
              this.day = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "前一天开工计划数量") {
              this.lastDayPlanNum = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "前一天开工完成数量") {
              this.lastDayNum = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "当天开工计划数量") {
              this.todayPlanNum = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "当天开工完成数量") {
              this.todayNum = (item.bl === null ? 0 : item.bl);
            }
          }
          this.$nextTick(() => {
            this.numberGrow(this.$refs.numberGrow1);
            this.numberGrow(this.$refs.numberGrow2);
            this.numberGrow(this.$refs.numberGrow3);
            this.refreshChart();
          });
        });
      },
      getPartKGList() {
        let params = {
          date: this.date,
          strType: "检修盒",
        };
        this.$http.get("basic","kanban/getPartKGList", params).then(res => {
          this.partKG = res;
        });
      },
      getPartKGHourSList() {
        let params = {
          date: this.date,
          strType: "检修盒",
        };
        this.$http.get("basic","kanban/getPartKGHourSList", params).then(res => {
          this.KGHour = [];
          this.KGValue = [];
          for(let item of res) {
            this.KGHour.push(item.scanHOUR);
            this.KGValue.push(item.sl);
          }
          this.$nextTick(() => {
            this.refreshChart3();
          });
        });
      },
      getPartKGsList() {
        let params = {
          date: this.date,
          strType: "检修盒",
        };
        this.$http.get("basic","kanban/getPartKGsList", params).then(res => {
          if(res.length > 0) {
            this.nowOrder = res[0];
            if(res.length > 1) {
              this.nextOrder = res[1];
            }
          }
        });
      },
      refreshChart() {
        let option1 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n昨天\n开工\n数量",
            left: "left",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.2),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.25),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.lastDayNum/this.lastDayPlanNum, this.lastDayNum/this.lastDayPlanNum],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                // formatter: ((this.lastDayNum/this.lastDayPlanNum) * 100).toFixed(2) + "%",
                formatter: this.lastDayNum + "\n\n总: " + this.lastDayPlanNum,
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart1.setOption(option1);

        let option2 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n当天\n开工\n数量",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.2),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.25),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.todayNum/this.todayPlanNum, this.todayNum/this.todayPlanNum],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                // formatter: ((this.todayNum/this.todayPlanNum) * 100).toFixed(2) + "%",
                formatter: this.todayNum + "\n\n总: " + this.todayPlanNum,
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart2.setOption(option2);
      },
      refreshChart3() {
        let option1 = {
          title:{
            text:" * 流水线小时产出数量",
            textStyle: {
              fontWeight: "normal",
              color: "RGB(255,255,255)",
            },
          },
          xAxis: {
            name: "时间",
            type: "category",
            data: this.KGHour,
            axisLine: {
              lineStyle: {
                // 设置x轴颜色
                color: "#fff",
              },
            },
          },
          yAxis: {
            name: "（台）",
            type: "value",
            axisLine: {
              lineStyle: {
                // 设置y轴颜色
                color: "#fff",
              },
            },
          },
          series: [{
            data: this.KGValue,
            type: "line",
            // 设置折线上圆点大小
            symbolSize:10,
            // 设置拐点为实心圆
            symbol:"circle",
          }],
          color: ["#42FFFF"],
        };
        this.myChart3.setOption(option1);
      },
      numberGrow(ele) {
        if (ele.dataset.value < 40) {
          ele.innerHTML = ele.dataset.value;
          return;
        }
        let step = Math.floor((ele.dataset.value * 5) / (ele.dataset.time * 100));
        let current = 0;
        let start = 0;
        let t = setInterval(function() {
          start += step;
          if (start > ele.dataset.value) {
            clearInterval(t);
            start = ele.dataset.value;
            t = null;
          }
          if (current === start) {
            return;
          }
          current = start;
          ele.innerHTML = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
        }, 10);
      },
      fontSize(res) {
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = 100 * (clientWidth / 1920);
        return res*fontSize;
      },
    },
  };
</script>

<style lang="scss">
  .jiaoDingLiuShuiXianKanban {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    background: url("/img/kanban_bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    color: #ffffff;
    .el-table, .el-table__expanded-cell, .el-table th, .el-table tr{
      background-color: transparent!important;
      color: #fff;
    }
    ::-webkit-scrollbar{
      width: 0.2vh;
    }
    ::-webkit-scrollbar-thumb{
      border-radius: 0.2vh;
      height: 5vh;
      background: #eee;
    }
    ::-webkit-scrollbar-track{
      box-shadow: inset 0 0 5vh rgba(0, 0, 0, 0.2);
      border-radius: 0.2vh;
      background: rgba(0,0,0,0.4);
    }
    .el-table__body tr:hover>td{
      background-color: #263445!important;
    }
    .el-table__body tr.current-row>td{
      background-color: #263445!important;
    }
    .el-table__header-wrapper th:nth-last-of-type(2){
      border-right: none;
    }
    .el-table--border td:nth-last-of-type(1){
      border-right: none;
    }
    .clear{
      clear:both
    }
    .number-grow {
      font-family: Arial-BoldMT;
      font-size: 7vh;
      color: #81C3FF;
      letter-spacing: 0.267vh;
      line-height: 7vh;
      margin-left: 3%;
    }
    .timeText {
      font-family: Arial-BoldMT;
      font-size: 4vh;
      line-height: 7vh;
      color: #fff;
    }
    .orderTable {
      height: 5vh;
      line-height: 5vh;
      font-size: 3.6vh;
      text-align:center;
      border: 0.1vh solid #fff;
    }
  }
</style>
